<template>
    <div>
        <b-modal size="lg" title="Aktualisierung der Kontaktdaten" ref="editModal" :ok-title="renew ? 'Verlängerte Lizenz erstellen' : 'Daten Aktualisieren'" cancel-title="Abbrechen" @ok="submit" lazy >
            <p v-if="renew">Bitte Prüfen Sie Ihre Kontaktdaten, bevor Ihnen eine neue Lizenz zugesendet wird.</p>
            <p v-else>Bitte geben Sie die aktualisierten Daten ein</p>

            <div><strong> Fachlicher Kontakt </strong></div>
            <edit-contact :contact.sync="contact"/>
            <div><strong> Kontakt der IT-Abteilung </strong></div>
            <edit-contact :contact.sync="itContact"/>
        </b-modal>
        <b-modal title="Daten werden aktualisiert" ref="updatingModal" hide-footer lazy no-fade>
            <p>
                <span class="fa fa-spin fa-spinner"/>
                Bitte warten
            </p>
        </b-modal>
        <b-modal title="Daten aktualisiert" ref="doneModal" ok-only ok-title="Schließen" lazy no-fade>
            <p v-if="renew">
                Ihre Daten wurden aktualisiert und die Lizenz wurde Verlängert.
            </p>
            <p v-else>
                Ihre Daten wurden aktualisiert
            </p>
        </b-modal>
        <b-modal title="Es trat ein Fehler auf" ref="errorModal" ok-only ok-title="Schließen" lazy no-fade>
            <p>Ihre Daten konnten nicht aktualisiert werden.</p>
            <p> {{ errorMessage }} </p>
        </b-modal>
    </div>

</template>

<script>
import EditContact from "./EditContact.vue";

export default {
  props: ["licenseKey", "licenseData", "licToolRoot"],
  data() {
    return {
      renew: false,
      contact: {},
      itContact: {},
      errorMessage: ''
    };
  },
  methods: {
    showForEdit() {
      this.$refs.editModal.show();
      this.renew = false;
      this.loadData();
    },
    showForRenew() {
      this.$refs.editModal.show();
      this.renew = true;
      this.loadData();
    },
    loadData() {
      this.contact = JSON.parse(JSON.stringify(this.licenseData.contact));
      this.itContact = JSON.parse(JSON.stringify(this.licenseData.itContact));
    },
    submit() {
      this.$refs.editModal.hide();
      this.$refs.updatingModal.show();
      let formData = new FormData();
      formData.append(
        "contactData",
        JSON.stringify({
          contact: this.contact,
          itContact: this.itContact
        })
      );
      this.$http
        .post(
          this.licToolRoot + "/customer/" +
            this.licenseKey +
            "/updateContacts.json",
          formData
        )
        .then(response => {
          if (this.renew) {
            this.doRenew();
          } else {
            this.showDone();
          }
        })
        .catch(this.onError);
    },
    doRenew() {
      // TODO: API url
      this.$http
        .post(
          this.licToolRoot + "/customer/" +
            this.licenseKey +
            "/prolong.json",
          new FormData()
        )
        .then(response => {
          this.showDone();
        })
        .catch(this.onError);
    },
    onError(e) {
      console.log("Displaying error", e);
      this.$refs.updatingModal.hide();
      this.$refs.errorModal.show();
      this.errorMessage = e.message;
    },
    showDone() {
      this.$refs.updatingModal.hide();
      this.$refs.doneModal.show();
      this.$emit('updated');
    }
  },
  components: {
    EditContact
  }
};
</script>
